export const iconFontAwesomeMathematicsGreaterThan = (
	<i className="fa-solid fa-greater-than"></i>
);
